import React from "react";

export interface RecentPlaceEntry {
  placeId: string;
  displayName: string;
  formattedAddress: string;
  lat: number | null;
  lng: number | null;
}

const STORAGE_KEY = "web-hailing-recent-places-v1";
const MAX_RECENTS = 4;

/** Rider-picked places, persisted across sessions. */
export function useRecentPlaces(): {
  recents: RecentPlaceEntry[];
  pushRecent: (place: RecentPlaceEntry) => void;
} {
  const [recents, setRecents] = React.useState<RecentPlaceEntry[]>(() => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw) as RecentPlaceEntry[];
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((r) => r && typeof r.displayName === "string").slice(0, MAX_RECENTS);
    } catch {
      return [];
    }
  });

  const pushRecent = React.useCallback((place: RecentPlaceEntry) => {
    setRecents((prev) => {
      const next = [place, ...prev.filter((r) => r.placeId !== place.placeId)].slice(0, MAX_RECENTS);
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        // persistence is a convenience
      }
      return next;
    });
  }, []);

  return { recents, pushRecent };
}
